import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-autoplay-info',
  templateUrl: './autoplay-info.component.html',
  styleUrls: ['./autoplay-info.component.scss'],
})
export class AutoplayInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
